import { makeSearchAutoCompleteBody } from 'services/helpers/search';

import { endpoints } from '../constants/endpoints';
import { sendRequest } from './sendRequest';

// backend requires widgetType which tells where you are calling this autocomplete api call from
export const searchAutoCompleteApi = ({ tagType, query, widgetType, teamId, employeeIds, empId, ...otherProps }) => {
  const body = makeSearchAutoCompleteBody({ tagType, query, teamId, employeeIds, ...otherProps });
  return sendRequest({
    url: endpoints.search.autoComplete,
    method: 'POST',
    body,
    queryParams: { widgetType, emp_id: empId },
    credentials: 'include',
  });
};

// backend requires widgetType which tells where you are calling this autocomplete api call from
export const searchAutoCompleteV1Api = ({
  text,
  tagTypeSet,
  widgetType,
  employeeIds,
  cohort,
  empId,
  timePeriod: timeBoundDetails,
}) => {
  const getBody = () => {
    if (cohort) {
      return {
        text,
        tagTypeSet,
        employeeIds,
        cohort,
      };
    }
    return {
      text,
      tagTypeSet,
      employeeIds,
      ...(timeBoundDetails ? { timeBoundDetails } : {}),
    };
  };
  return sendRequest({
    url: endpoints.search.autoCompleteV1,
    method: 'POST',
    body: getBody(),
    queryParams: { widgetType, emp_id: empId },
    credentials: 'include',
  });
};

export const searchAutoCompleteV2Api = ({ moduleType, searchText, offset = 0, limit = 1000, cohortId = undefined }) =>
  sendRequest({
    url: endpoints.search.autoCompleteV2,
    method: 'GET',
    queryParams: { moduleType, offset, limit, searchText, cohortId },
    credentials: 'include',
  });
